import { render } from "./ProfileRatings.vue?vue&type=template&id=d04c5142&ts=true"
import script from "./ProfileRatings.vue?vue&type=script&lang=ts"
export * from "./ProfileRatings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__